export default "__VITE_ASSET__B$auh2jH__"